import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceDatesFirstScan: {
        id: "app.space.details.spaceDates.firstScan.text",
        defaultMessage: "First Scan Captured on",
    },
    spaceDatesLastScan: {
        id: "app.space.details.spaceDates.lastScan.text",
        defaultMessage: "Last Scan Modified on",
    },
    spaceDatesLatestData: {
        id: "app.space.details.spaceDates.latestScan.text",
        defaultMessage: "Latest Data Update on",
    },
    spaceDatesLatestDataExchange: {
        id: "app.space.details.spaceDates.latestScan.Exchange.tooltip",
        defaultMessage: "Data Exchange",
    },
});
export default messages;
